import { TranslatedCalling } from './common';

function isLightColor(hexColor: string): boolean {
  const hex = hexColor.replace('#', '');
  const r = parseInt(hex.substring(0, 2), 16);
  const g = parseInt(hex.substring(2, 4), 16);
  const b = parseInt(hex.substring(4, 6), 16);
  const brightness = r * 0.299 + g * 0.587 + b * 0.114;
  return brightness > 128;
}

function ColorPalette({ palette }: { palette: string[] }) {
  return (
    <div className="mt-6 mb-4">
      <div className="flex border border-gray-200 rounded shadow overflow-hidden" style={{ width: 'fit-content' }}>
        {palette.map((color, index) => (
          <div key={index} className="w-20 h-20 relative" style={{ backgroundColor: color }} title={color}>
            <span
              className="absolute bottom-1 left-1 text-[9px] font-mono opacity-80"
              style={{
                color: isLightColor(color) ? '#000' : '#fff',
                textShadow: isLightColor(color) ? '0px 0px 2px rgba(255,255,255,0.7)' : '0px 0px 2px rgba(0,0,0,0.7)',
              }}
            >
              {color}
            </span>
          </div>
        ))}
      </div>
    </div>
  );
}

export const generate_palette = {
  type: 'thinking',
  call: () => <TranslatedCalling i18nKey="tool.generate-palette.should-be-fast" />,
  'partial-call': () => <TranslatedCalling i18nKey="tool.generate-palette.generating" />,
  result: (toolCall: any) => <ColorPalette palette={toolCall.result.palette} />,
};
